import React, { Suspense, lazy, Component } from 'react';
import { HashRouter, Routes, Route } from 'react-router-dom';
import { connect } from 'react-redux';
import { Checklogin, getAvlLanguages } from '../actions/user';
import { createTheme, ThemeProvider } from '@mui/material/styles';

import '../styles/global/style.css';
import 'react-notifications/lib/notifications.css';


// Lazy load components
const NotificationContainer = lazy(() => import('react-notifications').then(module => ({ default: module.NotificationContainer })));
const Login = lazy(() => import('../apps/login'));
const AdminDashboard = lazy(() => import('../apps/admin'));
const Register = lazy(() => import('../apps/registration/registration'));
const Activation = lazy(() => import('../apps/registration/activation'));
const PhysicianDashboard = lazy(() => import('../apps/physician'));


class Routers extends Component {
  componentDidMount() {
	  if(!window.location.hash.includes('#/account-activation/')) {
		this.props.dispatch(Checklogin());
	  }
    this.props.dispatch(getAvlLanguages());
  }

  render() {
    const { user } = this.props;

    if (user.isCheckLoginComplete === 'PENDING') {
      return <div>Loading...</div>;
    }

    const loginTheme = createTheme({
		components: {
		  MuiCssBaseline: {
			styleOverrides: {
			  body: {
				background: 'linear-gradient(45deg, #e6f7f5 30%, #e6f7f5 90%)',
				height: '100vh',
				margin: 0,
				padding: 0,
				boxSizing: 'border-box',
			  },
			},
		  },
		  MuiButton: {
			styleOverrides: {
			  root: {
				background: 'linear-gradient(66deg, #112C3B 30%, #509097 95%)',
				border: 0,
				borderRadius: 50,
				boxShadow: '0 3px 5px 2px rgba(255, 105, 135, .3)',
				color: 'white',
				height: 48,
				padding: '0 30px',
				'&:hover': {
				  background: 'linear-gradient(66deg, #509097 30%, #112C3B 95%)',
				  color: 'white',
				},
			  },
			},
		  },
		},
		typography: {
			body1: {
			//   fontSize: '1rem',
			  color: '#104A54', // Change the color for body text
			},
		},
		palette: {
		  primary: {
			main: '#112C3B',
		  },
		  secondary: {
			main: '#104A54',
		  },
		},
	  });
	  

    return (
      <Suspense fallback={<div>Loading...</div>}>
		<NotificationContainer/>
        {user.isCheckLoginComplete === 'FULFILLED' && (user.email_verified || user.user_type === 'admin') ? (
          <HashRouter>
            {user.user_type === 'physician' ? (
              <PhysicianDashboard />
            ) : (
              <AdminDashboard />
            )}
          </HashRouter>
        ) : (
          <HashRouter>
            <ThemeProvider theme={loginTheme}>
              <Routes>
			  	<Route exact path="/account-activation/:id" element={<Activation />} />
                <Route exact path="/register" element={<Register />} />
                <Route exact path="/" element={<Login />} />
              </Routes>
            </ThemeProvider>
          </HashRouter>
        )}
      </Suspense>
    );
  }
}

export default connect((store) => ({
  user: store.user,
}))(Routers);
